module.exports = __webpack_public_path__ + "static/logo-9329ea5459ccaaa797a25ad4c2e86dce.svg";